const auditComponentLoaders = Object.freeze({
  'audit.log-workspace': async () => {
    const module = await import('./audit-log-workspace-component.js');
    return module.AuditLogWorkspaceComponent;
  },
});

export default auditComponentLoaders;
